import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "keep-in-touch"
}
const _hoisted_2 = { class: "keep-in-touch__title" }
const _hoisted_3 = { class: "keep-in-touch__options" }
const _hoisted_4 = { class: "keep-in-touch__option-text" }
const _hoisted_5 = { class: "keep-in-touch__label" }
const _hoisted_6 = { class: "keep-in-touch__desc" }
const _hoisted_7 = { class: "keep-in-touch__option-text" }
const _hoisted_8 = { class: "keep-in-touch__label" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "prefs-modal",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_11 = { class: "prefs-modal__header" }
const _hoisted_12 = { class: "prefs-modal__title" }
const _hoisted_13 = { class: "prefs-modal__body" }
const _hoisted_14 = { class: "prefs-section" }
const _hoisted_15 = { class: "prefs-section__title" }
const _hoisted_16 = { class: "prefs-section__intro" }
const _hoisted_17 = { class: "prefs-row" }
const _hoisted_18 = { class: "prefs-row__text" }
const _hoisted_19 = { class: "prefs-row__label" }
const _hoisted_20 = { class: "prefs-row__desc" }
const _hoisted_21 = { class: "prefs-row" }
const _hoisted_22 = { class: "prefs-row__text" }
const _hoisted_23 = { class: "prefs-row__label" }
const _hoisted_24 = { class: "prefs-row__desc" }
const _hoisted_25 = { class: "prefs-section" }
const _hoisted_26 = { class: "prefs-section__title" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "prefs-row prefs-row--start" }
const _hoisted_29 = { class: "prefs-row__text" }
const _hoisted_30 = { class: "prefs-row__label" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "prefs-section" }
const _hoisted_33 = { class: "prefs-section__title" }
const _hoisted_34 = { class: "prefs-section__intro" }
const _hoisted_35 = { class: "prefs-row prefs-row--start" }
const _hoisted_36 = { class: "prefs-row__text" }
const _hoisted_37 = { class: "prefs-row__label" }
const _hoisted_38 = { class: "prefs-row__desc" }
const _hoisted_39 = { class: "prefs-modal__footer" }

import { computed, onMounted, reactive, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import Checkbox from '@/components/LoginRegister/common/inputs/Checkbox/v1/Checkbox.vue'
  import Button from '@/components/LoginRegister/common/Button/v1/Button.vue'
  import ToggleSwitch from '@/components/common/ToggleSwitch/v1/ToggleSwitch.vue'
  import isSubscribeNewsletter from '@/state/isSubscribeNewsletter'
  import registerForm from '@/state/registerForm'
  import { CdaConsent, defaultCdaConsent } from '@/types/CdaConsent'
  import { saveCdaConsent } from '@/logic/contact/cdaConsent'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'KeepInTouchOptIn',
  setup(__props) {

  const { t } = useI18n()
  const draft = reactive<CdaConsent>(defaultCdaConsent())
  const showForThisVisit = ref(true)
  const showPersonalize = ref(false)

  const stopIfLinkClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement | null
    if (target?.closest?.('a')) {
      event.stopPropagation()
    }
  }

  onMounted(() => {
    showForThisVisit.value = !isSubscribeNewsletter.value.email
  })

  const consent = computed(() => isSubscribeNewsletter.value)
  const visible = computed(() => showForThisVisit.value)

  const formEmail = computed(() => registerForm.value?.email?.trim() || '')

  /** Local state always; soft CRM push only when email already known (parity with funnel). */
  const commitConsent = async (next: CdaConsent) => {
    isSubscribeNewsletter.value = { ...next, whatsapp: false }
    if (formEmail.value) {
      await saveCdaConsent(formEmail.value, isSubscribeNewsletter.value)
    }
  }

  const toggleEmailDeals = async () => {
    const enabled = !consent.value.email
    await commitConsent({
      ...consent.value,
      email: enabled,
      trackingOpen: enabled,
    })
  }

  const togglePartenaires = async () => {
    await commitConsent({
      ...consent.value,
      partenaires: !consent.value.partenaires,
    })
  }

  const syncDraftFromConsent = () => {
    Object.assign(draft, { ...consent.value, whatsapp: false })
  }

  const openPersonalize = () => {
    syncDraftFromConsent()
    showPersonalize.value = true
  }

  const closePersonalize = (saved: boolean) => {
    if (!saved) syncDraftFromConsent()
    showPersonalize.value = false
  }

  const savePersonalize = async () => {
    await commitConsent({ ...draft, whatsapp: false })
    closePersonalize(true)
  }

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('loginRegister.keepInTouch.title')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Checkbox, {
            id: "optin-email-deals",
            active: consent.value.email,
            onCheckboxClick: toggleEmailDeals
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('loginRegister.keepInTouch.emailDealsLabel')), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('loginRegister.keepInTouch.emailDealsDesc')), 1)
              ])
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(Checkbox, {
            id: "optin-partenaires",
            active: consent.value.partenaires,
            onCheckboxClick: togglePartenaires
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('loginRegister.keepInTouch.partenairesLabel')), 1),
                _createElementVNode("span", {
                  class: "keep-in-touch__desc",
                  innerHTML: _unref(t)('loginRegister.keepInTouch.partenairesDesc'),
                  onClick: stopIfLinkClick
                }, null, 8, _hoisted_9)
              ])
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "keep-in-touch__personalize",
          onClick: openPersonalize
        }, _toDisplayString(_unref(t)('loginRegister.keepInTouch.personalize')), 1),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (showPersonalize.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "prefs-modal-backdrop",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (closePersonalize(false)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(t)('loginRegister.keepInTouch.personalizeTitle')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "prefs-modal__close",
                      "aria-label": "Close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (closePersonalize(false)))
                    }, " × ")
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("section", _hoisted_14, [
                      _createElementVNode("h4", _hoisted_15, _toDisplayString(_unref(t)('loginRegister.keepInTouch.sectionDealsTitle')), 1),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('loginRegister.keepInTouch.sectionDealsIntro')), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchEmail')), 1),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchEmailDesc')), 1)
                        ]),
                        _createVNode(ToggleSwitch, {
                          active: draft.email,
                          label: _unref(t)('loginRegister.keepInTouch.switchEmail'),
                          onToggle: _cache[1] || (_cache[1] = ($event: any) => (draft.email = !draft.email))
                        }, null, 8, ["active", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchSms')), 1),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchSmsDesc')), 1)
                        ]),
                        _createVNode(ToggleSwitch, {
                          active: draft.sms,
                          label: _unref(t)('loginRegister.keepInTouch.switchSms'),
                          onToggle: _cache[2] || (_cache[2] = ($event: any) => (draft.sms = !draft.sms))
                        }, null, 8, ["active", "label"])
                      ])
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "prefs-separator" }, null, -1)),
                    _createElementVNode("section", _hoisted_25, [
                      _createElementVNode("h4", _hoisted_26, _toDisplayString(_unref(t)('loginRegister.keepInTouch.sectionPartnersTitle')), 1),
                      _createElementVNode("p", {
                        class: "prefs-section__intro",
                        innerHTML: _unref(t)('loginRegister.keepInTouch.sectionPartnersIntro'),
                        onClick: stopIfLinkClick
                      }, null, 8, _hoisted_27),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchPartenaires')), 1),
                          _createElementVNode("span", {
                            class: "prefs-row__desc",
                            innerHTML: _unref(t)('loginRegister.keepInTouch.switchPartenairesDesc'),
                            onClick: stopIfLinkClick
                          }, null, 8, _hoisted_31)
                        ]),
                        _createVNode(ToggleSwitch, {
                          active: draft.partenaires,
                          label: _unref(t)('loginRegister.keepInTouch.switchPartenaires'),
                          onToggle: _cache[3] || (_cache[3] = ($event: any) => (draft.partenaires = !draft.partenaires))
                        }, null, 8, ["active", "label"])
                      ])
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "prefs-separator" }, null, -1)),
                    _createElementVNode("section", _hoisted_32, [
                      _createElementVNode("h4", _hoisted_33, _toDisplayString(_unref(t)('loginRegister.keepInTouch.sectionTrackingTitle')), 1),
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(t)('loginRegister.keepInTouch.sectionTrackingIntro')), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchTracking')), 1),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('loginRegister.keepInTouch.switchTrackingDesc')), 1)
                        ]),
                        _createVNode(ToggleSwitch, {
                          active: draft.trackingOpen,
                          label: _unref(t)('loginRegister.keepInTouch.switchTracking'),
                          onToggle: _cache[4] || (_cache[4] = ($event: any) => (draft.trackingOpen = !draft.trackingOpen))
                        }, null, 8, ["active", "label"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(Button, {
                      class: "w-100",
                      onButtonClick: savePersonalize
                    }, {
                      text: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('loginRegister.keepInTouch.save')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("button", {
                      type: "button",
                      class: "prefs-modal__back",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (closePersonalize(false)))
                    }, _toDisplayString(_unref(t)('loginRegister.keepInTouch.back')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      ]))
    : _createCommentVNode("", true)
}
}

})